let rafId: number | null = null;

export function cancelSmoothScroll() {
  if (rafId != null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
}


export function smoothScrollTo(targetY: number, duration = 700) {
  cancelSmoothScroll();

  const startY = window.scrollY || 0;
  const delta = targetY - startY;
  const start = performance.now();

  const easeInOut = (t: number) =>
    t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

  const step = (now: number) => {
    const progress = Math.min((now - start) / duration, 1);
    const eased = easeInOut(progress);

    window.scrollTo(0, startY + delta * eased);

    if (progress < 1) {
      rafId = requestAnimationFrame(step);
    } else {
      rafId = null;
    }
  };

  rafId = requestAnimationFrame(step);
}
